import React from "react";

import { IntegratorsDataProvider } from "../../../common/data/lookup-data-providers/IntegratorsDataProvider";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { SystemsDataProvider } from "../../../orders/common/data-providers/SystemsDataProvider";
import { SystemPlatformListing } from "../listing/SystemPlatformListing";
import { BuzzIdSection } from "./BuzzIdSection";
import { SystemPlatformsListingProvider } from "./context/SystemPlatformListingProvider";
import { ShreqIdSection } from "./ShreqIdSection";
import { SystemPlatformListingBreadcrumb } from "./SystemPlatformListingBreadcrumb";

export const SystemPlatformsListingPage: React.VFC = () => {
    return (
        <SystemPlatformsListingProvider>
            <PageHeader>
                <SystemPlatformListingBreadcrumb />
            </PageHeader>
            <IntegratorsDataProvider>
                <SystemsDataProvider>
                    <SystemPlatformListing />
                </SystemsDataProvider>
            </IntegratorsDataProvider>
            <BuzzIdSection />
            <ShreqIdSection />
        </SystemPlatformsListingProvider>
    );
};
